import React from 'react';
import { Modal, Button } from '@design-system';
import { CheckIcon } from '@design-system';
import { useTranslation } from 'react-i18next';
import { translations } from 'translations';

export const ErrorModal = ({ primaryColor, handleClose, isOpen }) => {
  const { t } = useTranslation();
  return (
    <Modal
      className="py-0"
      closeOnClickOutside={false}
      setShowModal={handleClose}
      showButtons={false}
      showCancel={false}
      showModal={isOpen}
      width="md:w-80">
      <>

        <p className="mb-10 text-center text-h4 font-bold">
          <span> {t(translations.DOCUMENT_PAGES.POPOVER_ANNOTATIONS)} </span>
        </p>

        <div className="flex justify-center">
          <Button
            className="px-8 text-white"
            size="sm"
            onClick={handleClose}
            variant="solid"
            color={primaryColor}>
            {t(translations.MODALS.NO_CREDIT_TO_CREATE_DOCUMENT_CLOSE)}
          </Button>
        </div>
      </>
    </Modal>
  );
};
